import requestCredentials from './requestCredentials'
import uploadFile from './uploadFile'
import completeUpload from './completeUpload'

export default async function (client, image) {
  const credentials = await requestCredentials(client, image)
  await uploadFile(credentials, image)
  await completeUpload(client, credentials.fileId)
  return credentials.fileId
}
